var _circle, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUniqueBishops(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 15,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9271 23.1725H19.6975C19.8466 22.9478 20.2576 22.1939 19.6496 21.449C19.0504 20.7149 17.9573 18.7867 18.0037 17.1135H18.244C18.5415 17.1135 18.7602 16.8724 18.7602 16.5749V16.5076C18.7602 16.2102 18.5415 15.969 18.244 15.969H17.9523V15.6806C18.8275 15.0766 19.3332 14.0984 19.3332 12.9935C19.3332 12.2979 18.8612 11.2357 18.2682 10.1847L17.0192 11.4366C16.8098 11.646 16.4684 11.646 16.2589 11.4366L16.1969 11.3738C15.9874 11.1645 15.9878 10.8217 16.1972 10.6122L17.6565 9.15309C17.3573 8.67719 17.0594 8.23226 16.8013 7.85889C16.9952 7.66164 17.1152 7.39141 17.1152 7.09284C17.1153 6.4893 16.6262 6 16.0225 6C15.4188 6 14.9296 6.4893 14.9296 7.09284C14.9296 7.39134 15.0495 7.66157 15.2434 7.85889C14.2616 9.27945 12.6893 11.7358 12.6893 12.9935C12.6893 14.128 13.2398 15.1292 14.115 15.7284V15.969H13.8008C13.5034 15.969 13.2398 16.2102 13.2398 16.5076V16.5749C13.2398 16.8724 13.5034 17.1135 13.8008 17.1135H14.0412C14.0876 18.7868 12.9946 20.7149 12.3953 21.449C11.7873 22.1939 12.1983 22.9478 12.3474 23.1725H12.1178C11.8203 23.1725 11.5568 23.4136 11.5568 23.7111V24.317C11.5568 24.5915 11.7587 24.8177 12.028 24.8509V26H19.972V24.8509C20.2413 24.8177 20.4433 24.5915 20.4433 24.317V23.7111C20.4433 23.4136 20.2245 23.1725 19.9271 23.1725Z",
    fill: "url(#paint0_linear_13_1748)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_13_1748",
    x1: 16,
    y1: 6,
    x2: 16,
    y2: 26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7AE249"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#51D115"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUniqueBishops);
export default __webpack_public_path__ + "static/media/uniqueBishops.42392891606c2b1a6f22e7190ecc2388.svg";
export { ForwardRef as ReactComponent };